import { useState } from "react";
export default function AiSpaAssistant() {
  const [inputValue, setInputValue] = useState("");
  const quickReplies = ["💰 Pricing Commission", "🔒 Bank-level Security", "⚡ Setup Time", "🔄 Integrations"];
  const handleQuickReply = (label: string) => {
    setInputValue(label);
  };
  return <section style={{
    backgroundColor: "rgb(255, 252, 247)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div className="flex flex-col items-center">
          <p style={{
          fontSize: "12px",
          fontWeight: 600,
          letterSpacing: "0.1em",
          color: "#C8985C",
          textAlign: "center",
          textTransform: "uppercase",
          marginBottom: "12px"
        }}>
            AI CONVERSION ASSISTANT
          </p>

          <h2 style={{
          color: "rgb(31, 58, 46)",
          fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          fontSize: "36px",
          fontWeight: "400",
          lineHeight: "40px",
          border: "0px solid oklch(0.69 0.04 165 / 0.25)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "16px"
        }}>
            Have Questions? Ask Our{" "}
            <em style={{
            color: "#C8985C",
            fontStyle: "italic"
          }}>Spa Assistant</em>
          </h2>

          <p style={{
          color: "rgba(42, 45, 43, 0.7)",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "24px",
          border: "0px solid oklch(0.69 0.04 165 / 0.25)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          maxWidth: "560px",
          marginBottom: "40px"
        }}>
            Get instant answers about pricing, integration, security, or connect directly with our onboarding specialists.
          </p>

          <div className="w-full" style={{
          maxWidth: "620px",
          borderRadius: "16px",
          boxShadow: "0px 4px 24px rgba(0,0,0,0.10)",
          overflow: "hidden"
        }}>
            <div style={{
            backgroundColor: "rgb(31, 58, 46)",
            padding: "0 20px",
            height: "64px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
              <div style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
                <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "9999px",
                backgroundColor: "rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                  <span style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center"
                }} dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>`
                }} />
                </div>
                <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px"
              }}>
                  <span style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#FFFFFF",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  lineHeight: "18px"
                }}>
                    PrepayQR Onboarding Assistant
                  </span>
                  <span style={{
                  fontSize: "10px",
                  fontWeight: 700,
                  color: "#C8985C",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  lineHeight: "14px"
                }}>
                    AUTOMATED &amp; ON-DEMAND
                  </span>
                </div>
              </div>

              <div style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "9999px",
              padding: "4px 10px"
            }}>
                <span style={{
                color: "white",
                display: "flex",
                alignItems: "center"
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>`
              }} />
                <span style={{
                fontSize: "12px",
                fontWeight: 500,
                color: "#FFFFFF",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                lineHeight: "16px"
              }}>
                  Secure Connection
                </span>
              </div>
            </div>

            <div style={{
            backgroundColor: "rgb(248, 247, 243)",
            padding: "16px 20px 0 20px"
          }}>
              <p style={{
              fontSize: "10px",
              fontWeight: 600,
              color: "rgba(42, 45, 43, 0.5)",
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              marginBottom: "8px",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif'
            }}>
                ASSISTANT
              </p>

              <div style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              boxShadow: "0px 1px 4px rgba(0,0,0,0.08)",
              padding: "16px 20px",
              marginBottom: "0px"
            }}>
                <p style={{
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "22px",
                color: "rgb(42, 45, 43)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                margin: 0
              }}>
                  Hello! Welcome to PrepayQR. I can help answer questions about setting up prepaid package sales at your massage tables, explain our pricing, or route you to a live specialist. What would you like to know?
                </p>
              </div>

              <div style={{
              height: "140px"
            }} />

              <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              marginBottom: "8px"
            }}>
                {quickReplies.map((label, i) => <button key={i} onClick={() => handleQuickReply(label)} style={{
                color: "rgb(31, 58, 46)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "12px",
                fontWeight: "500",
                lineHeight: "16px",
                backgroundColor: "rgb(255, 252, 247)",
                borderRadius: "3.35544e+07px",
                border: "1px solid rgba(31, 58, 46, 0.1)",
                padding: "6px 12px",
                textAlign: "center",
                animation: "none 0s ease 0s 1 normal none running",
                cursor: "pointer",
                transition: "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)"
              }} onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = "rgba(31, 58, 46, 0.05)";
              }} onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = "rgb(255, 252, 247)";
              }}>
                    {label}
                  </button>)}
              </div>

              <div style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              paddingBottom: "16px",
              paddingTop: "8px"
            }}>
                <input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} placeholder="Ask about pricing, security, setup, integrations..." style={{
                flex: 1,
                height: "40px",
                backgroundColor: "rgb(255, 252, 247)",
                border: "1px solid rgba(31, 58, 46, 0.15)",
                borderRadius: "9999px",
                paddingLeft: "16px",
                paddingRight: "16px",
                fontSize: "14px",
                fontWeight: 400,
                color: "rgb(42, 45, 43)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                outline: "none"
              }} />
                <button style={{
                width: "40px",
                height: "40px",
                borderRadius: "9999px",
                backgroundColor: "rgb(31, 58, 46)",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                transition: "opacity 0.15s ease, transform 0.15s ease"
              }} onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.opacity = "0.85";
                (e.currentTarget as HTMLButtonElement).style.transform = "scale(1.05)";
              }} onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.opacity = "1";
                (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)";
              }}>
                  <span style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center"
                }} dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path><path d="m21.854 2.147-10.94 10.939"></path></svg>`
                }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}